module.exports = __webpack_public_path__ + "static/media/pattern.e5f1e6b8.png";